import { MarketingLayoutProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: MarketingLayoutProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as MarketingLayoutProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      title: 'Large Size Layout',
      description:
        'This layout is very prominent, use it to promote apps or things like staff featured templates.',
    } as MarketingLayoutProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
